import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { generateAxiosInstanceCommon } from '../../hooks/useAuthorizedReuestCommon';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const InstituteDssPaymentReport = () => {
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    const authorizedAxiosCommon = generateAxiosInstanceCommon()
    let instituteMasterId = process.env.REACT_APP_REGISTER_INSTITUTE_ID;

    const initialFormState = {
        instituteMasterId: instituteMasterId,
        sectionMasterId: '',
        academicYearMasterId: '',
        instituteGradeMasterId: '',
        instituteDivisionMasterId: '',
        // isActive: true
    }


    const [sectionList, setSectionList] = useState([]);
    const [gradeList, setGradeList] = useState([])
    const [divisionList, setDivisionList] = useState([])
    const [yearList, setYearList] = useState([])
    const [studentData, setStudentData] = useState(initialFormState)
    const [paymentList, setPaymentList] = useState([])

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [sectionNameSort, setSectionNameSort] = useState(null);
    const [teacherNameSort, setTeacherNameSort] = useState(null);
    const [teacherEmailSort, setTeacherEmailSort] = useState(null);
    const [studentNameSort, setStudentNameSort] = useState(null);
    const [studentEmailSort, setStudentEmailSort] = useState(null);
    const [academicYearSort, setAcademicYearSort] = useState(null);
    const [dssTitleSort, setDssTitleSort] = useState(null);
    const [amountSort, setAmountSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = [
        "student.section",
        "teacher.name",
        "teacher.email",
        "student.name",
        "student.email",
        "student.academicYear",
        "student.grade",
        "student.division",
        "dssTitle",
        "orderId",
        "amount",
    ];


    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getSectionList();
    }, []);

    useEffect(() => {
        getStudentList();
    }, [studentData]);

    const getStudentList = async () => {
        try {
            const response = await authorizedAxiosCommon.get(getApiUrl());
            setPaymentList(response.data.result);
        } catch (error) {
            setPaymentList([]);
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getStudentList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setCurrPage(1);
            setPaymentList(await searchArray("C", getApiUrl(), searchKeys, searchValue.trim()));
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(paymentList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(paymentList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > paymentList.length) {
            endIndex = paymentList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(paymentList.slice(startIndex, endIndex));
    }, [paymentList, currPage, itemsPerPage]);

    const getSectionList = () => {
        const apiUrl = `/get-section?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setSectionList(response.data.result)
            })
            .catch(error => {
                setSectionList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getApiUrl = () => {
        let apiUrl = `/dss-payment-report?`;
        if (studentData.instituteMasterId !== '') {
            apiUrl += `instituteMasterId=${studentData.instituteMasterId}&`;
        }
        if (studentData.sectionMasterId !== '') {
            apiUrl += `sectionMasterId=${studentData.sectionMasterId}&`;
        }
        if (studentData.academicYearMasterId !== '') {
            apiUrl += `academicYearMasterId=${studentData.academicYearMasterId}&`;
        }
        if (studentData.instituteGradeMasterId !== '') {
            apiUrl += `instituteGradeMasterId=${studentData.instituteGradeMasterId}&`;
        }
        if (studentData.instituteDivisionMasterId !== '') {
            apiUrl += `instituteDivisionMasterId=${studentData.instituteDivisionMasterId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    const getYearList = (sectionMasterId) => {
        let apiUrl = `/get-sections-academic-years?`;
        if (sectionMasterId) {
            apiUrl += `sectionMasterId=${sectionMasterId}`;
        }
        apiUrl = apiUrl.replace(/&$/, '');
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setYearList(response.data.data)
            })
            .catch(error => {
                setYearList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getGradeList = (sectionMasterId) => {
        const apiUrl = `/get-app-register-section-grades?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setGradeList(response.data.result)
            })
            .catch(error => {
                setGradeList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        setStudentData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const handleSectionChange = (e) => {
        const { name, value } = e.target;
        setStudentData((prevData) => {
            return {
                ...prevData,
                [name]: value,
                instituteDivisionMasterId: '',
            }
        });

        getYearList(value);
        getGradeList(value);
    }

    const handleGradeChange = (e) => {
        const { name, value } = e.target;
        setStudentData((prevData) => {
            return {
                ...prevData,
                instituteDivisionMasterId: '',
                [name]: value
            }
        })

        const apiUrl = `/grade-wise-division?instituteMasterId=${instituteMasterId}&instituteGradeMasterId=${value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setDivisionList(response.data.result);
            })
            .catch(error => {
                setDivisionList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputReset = () => {
        setStudentData(initialFormState)
        setPaymentList([])

        setSectionNameSort(null);
        setTeacherEmailSort(null);
        setStudentEmailSort(null);
        setTeacherNameSort(null);
        setStudentNameSort(null);
        setAcademicYearSort(null);
        setDssTitleSort(null);
        setAmountSort(null);
    }


    useEffect(() => {
        if (sectionNameSort == true || sectionNameSort == false) {
            setTeacherEmailSort(null);
            setStudentEmailSort(null);
            setTeacherNameSort(null);
            setStudentNameSort(null);
            setAcademicYearSort(null);
            setDssTitleSort(null);
            setAmountSort(null);
        }
    }, [sectionNameSort])

    useEffect(() => {
        if (teacherEmailSort == true || teacherEmailSort == false) {
            setSectionNameSort(null);
            setStudentEmailSort(null);
            setTeacherNameSort(null);
            setStudentNameSort(null);
            setAcademicYearSort(null);
            setDssTitleSort(null);
            setAmountSort(null);
        }
    }, [teacherEmailSort])

    useEffect(() => {
        if (studentEmailSort == true || studentEmailSort == false) {
            setSectionNameSort(null);
            setTeacherEmailSort(null);
            setTeacherNameSort(null);
            setStudentNameSort(null);
            setAcademicYearSort(null);
            setDssTitleSort(null);
            setAmountSort(null);
        }
    }, [studentEmailSort])

    useEffect(() => {
        if (teacherNameSort == true || teacherNameSort == false) {
            setSectionNameSort(null);
            setTeacherEmailSort(null);
            setStudentEmailSort(null);
            setStudentNameSort(null);
            setAcademicYearSort(null);
            setDssTitleSort(null);
            setAmountSort(null);
        }
    }, [teacherNameSort])

    useEffect(() => {
        if (studentNameSort == true || studentNameSort == false) {
            setSectionNameSort(null);
            setTeacherEmailSort(null);
            setStudentEmailSort(null);
            setTeacherNameSort(null);
            setAcademicYearSort(null);
            setDssTitleSort(null);
            setAmountSort(null);
        }
    }, [studentNameSort])

    useEffect(() => {
        if (academicYearSort == true || academicYearSort == false) {
            setSectionNameSort(null);
            setTeacherEmailSort(null);
            setStudentEmailSort(null);
            setTeacherNameSort(null);
            setStudentNameSort(null);
            setDssTitleSort(null);
            setAmountSort(null);
        }
    }, [academicYearSort])

    useEffect(() => {
        if (dssTitleSort == true || dssTitleSort == false) {
            setSectionNameSort(null);
            setTeacherEmailSort(null);
            setStudentEmailSort(null);
            setTeacherNameSort(null);
            setStudentNameSort(null);
            setAcademicYearSort(null);
            setAmountSort(null);
        }
    }, [dssTitleSort])

    useEffect(() => {
        if (amountSort == true || amountSort == false) {
            setSectionNameSort(null);
            setTeacherEmailSort(null);
            setStudentEmailSort(null);
            setTeacherNameSort(null);
            setStudentNameSort(null);
            setAcademicYearSort(null);
            setDssTitleSort(null);
        }
    }, [amountSort])


    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/institute-dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Dss Payment Report</span></li>
                        </ol>
                    </nav>
                </div>

                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-users-line"></i>Dss Payment Report</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="sectionMasterId" className="col-form-label">Select Section</label>
                                                    <select class="form-select" aria-label="Default select example" name='sectionMasterId' onChange={handleSectionChange} value={studentData.sectionMasterId} >
                                                        <option selected value={''} disabled>Select Section</option>
                                                        {
                                                            sectionList?.map((section) => {
                                                                return <option value={section.id}>{section.sectionName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Academic Year :</label>
                                                    <select class="form-select" aria-label="Default select example" name='academicYearMasterId' onChange={handleInputChange} value={studentData.academicYearMasterId}>
                                                        <option selected value={''} disabled>Select Academic Year</option>
                                                        {
                                                            yearList?.map((list) => {
                                                                return <option value={list?.academicYearMasterDetails?.id}>{list?.academicYearMasterDetails?.yearName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Class :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteGradeMasterId' onChange={handleGradeChange} value={studentData.instituteGradeMasterId}>
                                                        <option selected value={''} disabled>Select Class</option>
                                                        {
                                                            gradeList?.map((grade) => {
                                                                return <option value={grade.instituteGradeMasterId}>{grade.instituteGradeMasterDetails.gradeName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Division :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteDivisionMasterId' onChange={handleInputChange} value={studentData.instituteDivisionMasterId}>
                                                        <option selected value={''} disabled>Select Division</option>
                                                        {
                                                            divisionList?.map((division) => {
                                                                return <option value={division.id}>{division.divisionName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        <button className="btn btn-danger delete_icon" type="button" style={{ marginRight: "20px" }} onClick={handleInputReset}>Reset</button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        {/* <div className="row mb-2">
                                                            <div className="col-md-6">
                                                                <button className={`${studentData.isActive ? 'active' : ''} btn btn-light btn-width`} onClick={() => setStudentData(prev => ({ ...prev, isActive: true }))}>Active List</button>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <button className={`${studentData.isActive ? '' : 'active'} btn btn-light btn-width`} onClick={() => setStudentData(prev => ({ ...prev, isActive: false }))}>Inactive List</button>
                                                            </div>
                                                        </div> */}
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope='col'>
                                                                            Section Name
                                                                            <SortIcon sortState={sectionNameSort} setSortState={setSectionNameSort} setData={setPaymentList} setCurrPage={setCurrPage} sortingPath={"student.section"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Teacher Name
                                                                            <SortIcon sortState={teacherNameSort} setSortState={setTeacherNameSort} setData={setPaymentList} setCurrPage={setCurrPage} sortingPath={"teacher.name"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Teacher Email
                                                                            <SortIcon sortState={teacherEmailSort} setSortState={setTeacherEmailSort} setData={setPaymentList} setCurrPage={setCurrPage} sortingPath={"teacher.email"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Student Name
                                                                            <SortIcon sortState={studentNameSort} setSortState={setStudentNameSort} setData={setPaymentList} setCurrPage={setCurrPage} sortingPath={"student.name"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Student Email
                                                                            <SortIcon sortState={studentEmailSort} setSortState={setStudentEmailSort} setData={setPaymentList} setCurrPage={setCurrPage} sortingPath={"student.email"} />
                                                                        </th>
                                                                        <th scope='col'>
                                                                            Academic Year
                                                                            <SortIcon sortState={academicYearSort} setSortState={setAcademicYearSort} setData={setPaymentList} setCurrPage={setCurrPage} sortingPath={"student.academicYear"} />
                                                                        </th>
                                                                        <th scope='col'>
                                                                            Class
                                                                        </th>
                                                                        <th scope='col'>
                                                                            Division
                                                                        </th>
                                                                        <th scope='col'>
                                                                            Dss Title
                                                                            <SortIcon sortState={dssTitleSort} setSortState={setDssTitleSort} setData={setPaymentList} setCurrPage={setCurrPage} sortingPath={"dssTitle"} />
                                                                        </th>
                                                                        <th scope='col'>
                                                                            Order Id
                                                                        </th>
                                                                        <th scope='col'>
                                                                            Amount
                                                                            <SortIcon sortState={amountSort} setSortState={setAmountSort} setData={setPaymentList} setCurrPage={setCurrPage} sortingPath={"amount"} />
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData?.length > 0 ?
                                                                            displayedData?.map((dss, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{dss.student.section}</td>
                                                                                        <td>{dss.teacher.name}</td>
                                                                                        <td>{dss.teacher.email}</td>
                                                                                        <td>{dss.student.name}</td>
                                                                                        <td>{dss.student.email}</td>
                                                                                        <td>{dss.student.academicYear}</td>
                                                                                        <td>{dss.student.grade}</td>
                                                                                        <td>{dss.student.division}</td>
                                                                                        <td>{dss.dssTitle}</td>
                                                                                        <td>{dss.orderId}</td>
                                                                                        <td>{dss.amount}</td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Payments Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={paymentList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default InstituteDssPaymentReport
